import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface SubscriptionsChartProps {
  data: { month: string; value: number }[];
}

const SubscriptionsChart: React.FC<SubscriptionsChartProps> = ({ data }) => {
  // Calculate total subscriptions from the data
  const totalSubscriptions = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="chart-container">
      <div className="chart-header">
        <div>
          <h3>Subscriptions</h3>
          <p>See how your users expands</p>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 10, fill: "#677289" }}
            axisLine={false}
            tickLine={false}
            interval={0}
            angle={-45}
            textAnchor="end"
            height={60}
          />
          <YAxis
            tick={{ fontSize: 12, fill: "#677289" }}
            axisLine={false}
            tickLine={false}
            ticks={[0, 25, 50, 75]}
            domain={[0, 75]}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e7ecf1",
              borderRadius: "8px",
            }}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#D7A360"
            strokeWidth={2}
            dot={{ fill: "#D7A360", r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        <div className="legend-item">
          <span className="legend-dot" style={{ backgroundColor: "#D7A360" }}></span>
          <span className="legend-label">Daily Subscriptions</span>
        </div>
      </div>
      {/* <div className="total-count">
        <p>Total (Last 15 Days)</p>
        <h2>{totalSubscriptions}</h2>
      </div> */}
    </div>
  );
};

export default SubscriptionsChart;
